import _ from 'lodash';
import { setSession, clearSession } from 'libs/sessionStorage';
import * as userHelper from 'helpers/Users';
import { isPending as isTestPending } from 'helpers/RequestTestsHelper';
import {
  isPending as isRequestPending,
  isSaved,
  isRequesttWithdrawn
} from 'helpers/RequestHelper';
import * as actions from 'actions/types';

const setRequestPermissions = (action, state) => {
  if (!action.payload.data) return state;

  const request = action.payload.data.data;
  const { id, requeststatusid } = request;

  let canEditRequest = _.isUndefined(state.canEditRequest)
    ? false
    : state.canEditRequest;
  let canUploadRequestDocs = _.isUndefined(state.canUploadRequestDocs)
    ? false
    : state.canUploadRequestDocs;
  let togglerEnabled = _.isUndefined(state.togglerEnabled)
    ? false
    : state.togglerEnabled;
  let selectedRequestId = id;

  // Vendor user able to edit request data only if
  // request tests have Pending status, but
  // this checks we able to do only when have
  // test statuses (see `setRequestTestPermissions` method)
  // Also should not be able to edit request if its status is `Withdrawn`
  if (state.isVendor) {
    canEditRequest = isRequesttWithdrawn(request.requeststatusid)
      ? false
      : undefined;
    canUploadRequestDocs =
      isRequestPending(requeststatusid) || isSaved(requeststatusid);
  }

  // Staff users unable to modify request data by default
  // Only CTIA Staff can do that after clicks 'Modify' on Request page
  if (state.isStaff && !state.ctiaStaff) {
    canEditRequest = false;
    canUploadRequestDocs = false;
  }

  // check if CTIA Staff user already enabled Modify mode before
  // if (isCTIAUser(state) && state.canEditRequest === true) {
  if (
    userHelper.isCTIAUser(state) &&
    state.togglerEnabled === true &&
    state.selectedRequestId !== selectedRequestId
  ) {
    canEditRequest = false;
    canUploadRequestDocs = false;
    togglerEnabled = false;
  }

  // if not owner trying to edit someone's request
  // we have to change owner company id in that case
  const requestOwnerCompanyId = userHelper.getRequestOwner(request, state);

  return {
    ...state,
    canEditRequest,
    canUploadRequestDocs,
    togglerEnabled,
    selectedRequestId,
    requestOwnerCompanyId
  };
};

const setRequestTestPermissions = (action, state) => {
  if (!action.payload.data) return state;

  let canEditRequest = state.canEditRequest;

  // Vendor user able to edit request data only if
  // request tests have Pending status
  // If flag is not already set (undefined), don't need to check that
  if (state.isVendor && _.isUndefined(canEditRequest)) {
    const testStatus = action.payload.data.data.length
      ? action.payload.data.data[0].requestteststatusid
      : null;
    canEditRequest = isTestPending(testStatus);
  }

  return { ...state, canEditRequest };
};

const setSubmitPermissions = state => {
  return {
    ...state,
    canEditRequest: true,
    canUploadRequestDocs: true,
    togglerEnabled: undefined
  };
};

const dropRequestPermissions = (action, state) => {
  if (!action.payload.data) return state;

  const request = action.payload.data.data;

  if (request.id !== state.selectedRequestId) {
    return dropAllRequestPermissions(state);
  }

  return state;
};

const dropAllRequestPermissions = state => {
  return {
    ...state,
    canEditRequest: undefined,
    togglerEnabled: undefined,
    canUploadRequestDocs: undefined
  };
};

const updateUserInfo = user => {
  const userData = { ...user };

  // define user role
  const role = userHelper.defineUserRole(userData.role);

  // set CTIA user flag
  const ctiaStaff = userHelper.isCTIAUser(userData);

  const updatedUserData = {
    ...userData,
    name: userHelper.getFullName(userData),
    role,
    ctiaStaff,
    isVendor: userHelper.isVendor(role),
    isLab: userHelper.isLab(role),
    isStaff: userHelper.isStaff(role),
    isAccountant: userHelper.isAccountant(role),
    accessError: role ? false : true
  };

  // update user session values
  setSession('user', updatedUserData);

  // update redux store
  return updatedUserData;
};

export default function(state = null, action) {
  switch (action.type) {
    case actions.LOGOUT:
      clearSession();
      return null;
    case actions.AGREE_TERMS:
      const terms = action.payload;
      setSession('terms', terms);
      return { ...state, terms };
    case actions.FETCH_REQUEST:
      // need first to drop current settings if fetching new one request
      const droppedState = dropRequestPermissions(action, state);
      return setRequestPermissions(action, droppedState);
    case actions.NEW_REQUEST_INIT:
      return setSubmitPermissions(state);
    case actions.TOGGLE_REQUEST_EDIT_MODE:
      const currentEditState = state.canEditRequest;
      const currentEditDocsState = state.canUploadRequestDocs;
      const currentTogglerState = state.togglerEnabled;
      return {
        ...state,
        togglerEnabled: !currentTogglerState,
        canEditRequest: !currentEditState,
        canUploadRequestDocs: !currentEditDocsState
      };
    case actions.FETCH_REQUEST_TESTS:
      return setRequestTestPermissions(action, state);
    case actions.FETCH_CERTIFICATION_REQUESTS:
    case actions.RETURN_TO_EDIT_REQUEST:
      return dropAllRequestPermissions(state);
    case actions.GET_USER_INFO:
      return updateUserInfo({ ...state, ...action.payload });
    case actions.SAVE_USER_TOKEN:
      const token = action.payload;
      setSession('user', { token });
      return { ...state, token };
    case actions.SET_ACCESS_ERROR_FLAG:
      return { ...state, accessError: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js